module.exports = __webpack_public_path__ + "media/images/hospital-staff-660a7af194f8cf9bcfa5792b9dd27d19.jpg";